import ApiService from "./ApiService";

const authenticationService = {
  async login(login: string, password: string): Promise<TokenResponse> {
    return ApiService.post("/login", { login, password });
  },

  async getMqttCredentials(userId: number): Promise<MqttCredentials> {
    return ApiService.get("/authentication/mqtt", { userId });
  },

  async revokeMqttCredentials(userId: number): Promise<void> {
    return ApiService.delete(`/authentication/mqtt?userId=${userId}`);
  },
};

export default authenticationService;
